import { useRouterStore } from "../stores/StoreContext"
import { routes } from "./routes"

export const NotFoundPage = () => {
  const router = useRouterStore()

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <p className="text-xl mb-6">Page not found</p>
        <button
          type="button"
          onClick={() => router.goTo(routes.home)}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
        >
          Go Home
        </button>
      </div>
    </div>
  )
}
